<template>
  <div class="hidden-sm-and-up bg">
    <div class="mobile_callme_wrap">
      <p v-if="icpLines[0]">{{ icpLines[0] }}</p>
      <p v-if="icpLines[1]">{{ icpLines[1] }}</p>
      <p v-if="icpLines[2]">{{ icpLines[2] }}</p>
    </div>
    <div class="navigate_wrap">
      <!-- <span>友情链接:</span> -->
      <a :href="link.url" v-for="link in linkList">{{ link.linkName }}</a>
    </div>
  </div>
</template>

<script>
import { getAllLinks } from '../../api/system';

export default {
  data() {
    return {
      linkList: []
    }
  },
  computed: {
    globalDicts() {
      return this.$store.getters.getDicts;
    },
    icpLines() {
    const icpText = this.globalDicts['icp'] || '';
    if (!icpText) return [];
    
    const parts = icpText.split('.');

    return [`${parts[0]}`, parts[1], parts[2] || ''];
  }
  },
  methods: {
    async getAllLinksFunc() {
      const res = await getAllLinks()
      if (res.data) {
        this.linkList = res.data.data
      }
    }
  },
  mounted() {
    this.getAllLinksFunc()
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background: #21282d;
  // background-size: cover;
}

.mobile_callme_wrap {
  width: 100%;
  height: 100PX;
  margin-top: 20PX;
  padding: 30PX;
  box-sizing: border-box;

  p {
    font-size: 4vw;
    color: #fff;
    line-height: 20PX;
    text-align: center;
    width: 100%;
  }
}

.navigate_wrap {
  width: 100%;
  margin-top: 40px;
  padding: 0 10PX 20PX 10PX;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  // word-break: keep-all;
  // word-wrap: break-word;
  a {
    color: #ccc;
    font-size: 13PX;
    margin-right: 11PX;
    text-decoration: underline;
  }

  span {
    color: #fff;
    padding-right: 10PX;
    font-size: 16PX;
    margin-right: 0;
  }

  p {
    font-size: 16PX;
    color: #4e5557;
  }
}
</style>